import React, { Component } from 'react';
import '../../styles/components/header-banner.scss';
import i18n from '../../i18n';

class HeaderBanner extends Component {
  render() {
    const { title, subtitle, variant, icon } = this.props;

    return (
      <>
         <div className="hero-dash-banner">
          <div className="hero-dash-content">
            <h1 className="hero-dash-title">
              {icon && <span className="header-dash-icon">{icon}</span>}
              {title}
              </h1>
              {subtitle && <p className="hero-dash-subtitle">{subtitle}</p>}
          </div>
        </div>
      </>
    );
  }
}

export default HeaderBanner;
